import { IParentPage } from '../../types/shared';

interface ParsedParentPage {
  label: string;
  path: string;
  pages: ParsedParentPage[];
}

const parseSlug = (slug: string): string => {
  if (slug === '#' || slug === '/') {
    return '/';
  }

  return `${slug}/`;
};

const parseNestedParentPages = (
  page: IParentPage | undefined
): ParsedParentPage[] =>
  page
    ? [
        {
          label: page.name || '',
          path: parseSlug(page.slug),
          pages: parseNestedParentPages(page.parentPage),
        },
      ]
    : [];

const getPagesPathRecursively = (
  pages: ParsedParentPage[],
  segments: string[]
): string => {
  if (pages.length) {
    segments.push(pages[0].path);

    getPagesPathRecursively(pages[0].pages, segments);
  }

  return [...segments].reverse().join('');
};

const parseURLWithParentPage = (
  slug: string,
  page: IParentPage | undefined
) => {
  const formattedSlug = `${slug}${!slug.endsWith('/') ? '/' : ''}`;

  if (!page) {
    return `/${formattedSlug}`;
  }

  const parsedParentPages = parseNestedParentPages(page);

  return `${getPagesPathRecursively(parsedParentPages, [])}${formattedSlug}`;
};

export {
  getPagesPathRecursively,
  parseNestedParentPages,
  parseURLWithParentPage,
};
